import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <footer>© {new Date().getFullYear()} - Rehearsal Notice</footer>
    </div>
  );
};

export default Footer;
